/* Baner zgód (cookie consent) wpięty w Shopify Customer Privacy API.
   Pokazuje modal gdy shouldShowGDPRBanner(); zapisuje wybór przez setTrackingConsent.
   Wszystkie = wszystko on; Tylko niezbędne = wszystko off; Dostosuj = per kategoria.
   Re-open: dowolny element [data-cc-open]. */
(function () {
  var root;

  function lock(on) {
    document.documentElement.classList.toggle('gg-cc-lock', on);
    document.body.classList.toggle('gg-cc-lock', on);
  }
  function show() { if (root) { root.hidden = false; lock(true); } }
  function hide() { if (root) { root.hidden = true; lock(false); root.classList.remove('gg-cc--customize'); } }

  function cp() {
    return (window.Shopify && Shopify.customerPrivacy) ? Shopify.customerPrivacy : null;
  }

  function setConsent(consent, done) {
    var api = cp();
    if (api && api.setTrackingConsent) {
      try { api.setTrackingConsent(consent, function () { if (done) done(); }); return; }
      catch (e) { /* fallthrough */ }
    }
    if (done) done();
  }

  function acceptAll() {
    setConsent({ analytics: true, marketing: true, preferences: true, sale_of_data: true }, hide);
  }
  function rejectAll() {
    setConsent({ analytics: false, marketing: false, preferences: false, sale_of_data: false }, hide);
  }
  function saveCustom() {
    var a = !!root.querySelector('[data-cc-analytics]').checked;
    var m = !!root.querySelector('[data-cc-marketing]').checked;
    var p = !!root.querySelector('[data-cc-preferences]').checked;
    setConsent({ analytics: a, marketing: m, preferences: p, sale_of_data: m }, hide);
  }

  function prefill() {
    var api = cp();
    if (!api || !api.currentVisitorConsent) return;
    var c;
    try { c = api.currentVisitorConsent(); } catch (e) { return; }
    if (!c) return;
    var map = { analytics: '[data-cc-analytics]', marketing: '[data-cc-marketing]', preferences: '[data-cc-preferences]' };
    Object.keys(map).forEach(function (k) {
      var el = root.querySelector(map[k]);
      if (el) el.checked = (c[k] === 'yes' || c[k] === true);
    });
    syncMaster();
  }

  function syncMaster() {
    var master = root.querySelector('[data-cc-all-toggle]');
    if (!master) return;
    var a = root.querySelector('[data-cc-analytics]'),
        m = root.querySelector('[data-cc-marketing]'),
        p = root.querySelector('[data-cc-preferences]');
    master.checked = !!(a && a.checked && m && m.checked && p && p.checked);
  }

  function openCustomize() { prefill(); root.classList.add('gg-cc--customize'); }

  function bind() {
    root = document.querySelector('[data-gg-cc]');
    if (!root) return false;
    var q = function (s) { return root.querySelector(s); };
    if (q('[data-cc-all]')) q('[data-cc-all]').addEventListener('click', acceptAll);
    if (q('[data-cc-necessary]')) q('[data-cc-necessary]').addEventListener('click', rejectAll);
    if (q('[data-cc-customize]')) q('[data-cc-customize]').addEventListener('click', openCustomize);
    if (q('[data-cc-back]')) q('[data-cc-back]').addEventListener('click', function () { root.classList.remove('gg-cc--customize'); });
    if (q('[data-cc-save]')) q('[data-cc-save]').addEventListener('click', saveCustom);

    // „Zaznacz wszystko" — master toggle zaznacza/odznacza wszystkie regulowane kategorie
    var cats = ['[data-cc-analytics]', '[data-cc-marketing]', '[data-cc-preferences]'];
    var master = q('[data-cc-all-toggle]');
    if (master) master.addEventListener('change', function () {
      cats.forEach(function (s) { var el = q(s); if (el) el.checked = master.checked; });
    });
    cats.forEach(function (s) { var el = q(s); if (el) el.addEventListener('change', syncMaster); });

    // Re-open zgód z dowolnego miejsca (np. link w stopce)
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-cc-open]') : null;
      if (t) { e.preventDefault(); prefill(); show(); }
    });
    return true;
  }

  function maybeShow() {
    if (!window.Shopify || !Shopify.loadFeatures) return;
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err) return;
      try {
        if (Shopify.customerPrivacy.shouldShowGDPRBanner()) { show(); }
      } catch (e) { /* noop */ }
    });
  }

  function init() {
    if (!bind()) return;
    maybeShow();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
